import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Switch,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import GradeIcon from "@mui/icons-material/Grade";

const notificationTypes = [
  { id: "games", label: "Game Updates" },
  { id: "analysis", label: "Analysis Updates" },
  { id: "score", label: "Overall Score Changes" },
  { id: "intel", label: "Intel Updates" },
  { id: "nil", label: "NIL Value Updates" },
  { id: "highlights", label: "New Highlights Added" },
];

const NotificationsModal = ({ open, onClose, playerId }) => {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    if (playerId) {
      const savedSettings = localStorage.getItem(
        `notificationSettings_${playerId}`
      );
      setSettings(
        savedSettings
          ? JSON.parse(savedSettings)
          : notificationTypes.reduce(
              (acc, type) => ({ ...acc, [type.id]: false }),
              {}
            )
      );
    }
  }, [playerId]);

  const handleToggle = (id) => {
    setSettings((prev) => {
      const newSettings = {
        ...prev,
        [id]: !prev[id],
      };
      // Only save if we have a playerId
      if (playerId) {
        localStorage.setItem(
          `notificationSettings_${playerId}`,
          JSON.stringify(newSettings)
        );
      }
      return newSettings;
    });
  };

  return (
    <Dialog
      className="notification-dialog"
      open={open}
      onClose={onClose}
      aria-labelledby="notification-settings"
      disablePortal={false}
      keepMounted={false}
      disableEnforceFocus={false}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          color: "white",
        }}
      >
        Notification Settings
        <IconButton
          edge="end"
          color="inherit"
          onClick={onClose}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <List>
          {notificationTypes.map(({ id, label }) => (
            <ListItem key={id} className="notification-list-item">
              <ListItemIcon>
                <GradeIcon sx={{ color: "#b0b0b0", fontSize: 30 }} />
              </ListItemIcon>
              <ListItemText primary={label} />
              <Switch
                edge="end"
                checked={settings[id]}
                onChange={() => handleToggle(id)}
                inputProps={{
                  "aria-labelledby": `switch-${id}`,
                }}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
    </Dialog>
  );
};

export default NotificationsModal;
